module.exports = __webpack_public_path__ + "img/bigTruck-green.0c02c7c6.svg";